import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
type TeamDTO = {
    id:string;
    name:string;
    email:string;
    description:string
    img_url:string;
    title:string;
    createdAt:string;
    updatedAt:string;
};

type getTeamResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: TeamDTO[];
};
export const GetAllTeam = async (
): Promise<getTeamResponse> => {
  try {
    const response = await axios.get(`/team/all`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
